import type Fuse from 'fuse.js';

export type FuseSearchQuery = Fuse.Expression | string;

/**
 * Convert to a fuse search token.
 */
function toFuseSearchToken(
    token: string,
    /**
     * Min token length.
     * @default 1
     */
    minLength: number = 1
): string {
    if (token.length <= minLength) {
        // ' means exact match for token, see https://www.fusejs.io/api/query.html#use-with-extended-searching
        return `'${token}`;
    }
    return token;
}

/**
 * Buikld a Fuse search query.
 */
export function buildFuseSearchQuery(
    tokens: string[],
    fields: string[],
    options?: {
        /**
         * Optional min token length.
         * @default 1
         */
        minTokenLength?: number;
    }
): FuseSearchQuery {
    if (tokens.length <= 1) {
        return tokens[0] ?? '';
    }
    return {
        $and: tokens.map((token) => {
            const searchToken = toFuseSearchToken(token, options?.minTokenLength);
            return {
                $or: fields.map((field) => ({ [field]: searchToken })) as Fuse.Expression[],
            };
        }),
    };
}
